<template>
  <el-row class="core_three_wrap">
    <el-col class="three_left">
      <div class="left_tit">
        {{ $t('coreCompetence.team.upgradeTitle') }}
      </div>
      <div class="left_desc">
        <div class="desc_item" v-for="(capability, index) in capabilities" :key="index">
          <div class="item_left">
            <img :src="getImagePath(index)" alt="">
          </div>
          <div class="item_right">
            <p>{{ capability.title }}</p>
            <p>{{ capability.description }}</p>
          </div>
        </div>
      </div>
    </el-col>
    <el-col class="three_right">
      <img src="@/assets/img/right3 (1).png" alt="" />
    </el-col>
  </el-row>
</template>

<script>
export default {
  computed: {
    capabilities() {
      const c = this.$t('coreCompetence.team.capabilities', { returnObjects: true });
      return Array.isArray(c) ? c : [];
    }
  },
  methods: {
    getImagePath(index) {
      const images = [
        require('@/assets/xiazai.png'),
        require('@/assets/img/xiazai2.png'),
        require('@/assets/img/xiazai3.png'),
        require('@/assets/img/xiazai4.png')
      ];
      return images[index] || images[0];
    }
  }
}
</script>

<style lang="scss" scoped>
.core_three_wrap {
  display: flex;
  justify-content: center;
  text-align: left;
  @media screen and (max-width: 768px) {
    flex-wrap: wrap;
  }
  .three_left {
    width: 40%;
    @media screen and (max-width: 768px) {
      width: 90%;
    }
    .left_tit{
      color: #3e3e3e;
      font-size: 20px;
      font-weight: bold;
      @media screen and (max-width: 768px) {
        font-size: 1.2rem;
        margin-top: 20PX;
      }
    }
    .left_desc{
      .desc_item{
        margin-top: 40px;
        display: flex;
        align-items: center;
        padding-left: 50px;
        .item_left{
          img{
            width: 50px;
            height: 50px;
          }
        }
        .item_right{
          margin-left: 20px;
          p{
            margin: 0;
            &:nth-child(1){
              color: #717171;
              font-size: 16px;
              font-weight: bold;
              @media screen and (max-width: 768px) {
                font-size: 1rem;
                margin-top: 20PX;
              }
            }
            &:nth-child(2){
              color: #717171;
              font-size: 14px;
              padding: 6px 0;
              @media screen and (max-width: 768px) {
                font-size: 0.8rem;
              }
            }
          }
        }
      }
    }
  }
  .three_right {
    width: 20%;
    height: 100%;
    margin-left: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    @media screen and (max-width: 768px) {
      width: 100%;
      margin-top: 20PX;
    }
    img {
      width: 80%;
      margin-top: 40px;
    }
  }
}
</style>